import { render, staticRenderFns } from "./FormTextItem.vue?vue&type=template&id=618a2afd"
import script from "./FormTextItem.vue?vue&type=script&lang=js"
export * from "./FormTextItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('618a2afd')) {
      api.createRecord('618a2afd', component.options)
    } else {
      api.reload('618a2afd', component.options)
    }
    module.hot.accept("./FormTextItem.vue?vue&type=template&id=618a2afd", function () {
      api.rerender('618a2afd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/formItems/FormTextItem.vue"
export default component.exports